import CategoryCollectionPage from './CategoryCollectionPage';
import { BALONY_CONFIG } from './categoryPageConfigs';
export default function BalonyzHelemPage() {
  return <CategoryCollectionPage config={BALONY_CONFIG} />;
}
